import { render } from "./ModalOrder.vue?vue&type=template&id=5d78f71b&scoped=true"
import script from "./ModalOrder.vue?vue&type=script&lang=js"
export * from "./ModalOrder.vue?vue&type=script&lang=js"

import "./ModalOrder.vue?vue&type=style&index=0&id=5d78f71b&scoped=true&lang=scss"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d78f71b"]])

export default __exports__